// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Voice Interface - Production voice-only interface styling */
.voice-interface {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
  background: #191d26; /* Match standalone background */
  justify-content: center; /* Center voice panel vertically */
  align-items: center; /* Center voice panel horizontally */
}

/* Voice panel should be centered, not fixed */
.voice-interface .voice-control-bar-container {
  position: relative;
  width: 100%;
  max-width: 600px; /* Reasonable max width for centered content */
}
`, "",{"version":3,"sources":["webpack://./src/styles/interfaces/voice-interface.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB,EAAE,gCAAgC;EACrD,uBAAuB,EAAE,kCAAkC;EAC3D,mBAAmB,EAAE,oCAAoC;AAC3D;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB,EAAE,8CAA8C;AAClE","sourcesContent":["/* Voice Interface - Production voice-only interface styling */\n.voice-interface {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background: #191d26; /* Match standalone background */\n  justify-content: center; /* Center voice panel vertically */\n  align-items: center; /* Center voice panel horizontally */\n}\n\n/* Voice panel should be centered, not fixed */\n.voice-interface .voice-control-bar-container {\n  position: relative;\n  width: 100%;\n  max-width: 600px; /* Reasonable max width for centered content */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
